/**************************************************
 * Nombre:       Pagina
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Seccion_Home from "./Secciones/Seccion_Home";
import Barra from "./Barra/Barra";
import Footer from "./Footer";
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import Seccion_Nosotros from "./Secciones/Seccion_Nosotros";
import Seccion_Locales from "./Secciones/Seccion_Locales";
import Seccion_PorMayor from "./Secciones/Seccion_PorMayor";
import {useCarritoFlotante} from "../Modulo_Carrito_Flotante/Hooks/useCarritoFlotante";

const Pagina = () => {
    const {CarritoFlotante} = useCarritoFlotante();

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Router>
                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', zIndex: 2}}>
                    <Barra/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', zIndex: 1}}>
                    <Routes>
                        <Route path={"*"} element={<Seccion_Home/>}/>
                        <Route path={"/"} element={<Seccion_Home/>}/>
                        <Route path={"/Home"} element={<Seccion_Home/>}/>
                        <Route path={"/Nosotros"} element={<Seccion_Nosotros/>}/>
                        <Route path={"/Locales"} element={<Seccion_Locales/>}/>
                        <Route path={"/PorMayor"} element={<Seccion_PorMayor/>}/>
                    </Routes>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                    <Footer/>
                </Grid>


                    <CarritoFlotante/>



            </Router>

        </Grid>
    )

}
export default Pagina